import React from 'react'
import { Link } from "react-router-dom";


const CoronavirusInfections = () => {
    return (
        <>

            <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
                <div className="auto-container">
                    <h2>Coronavirus</h2>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li style={{ color: "green" }}>Coronavirus Infections</li>
                    </ul>
                </div>
            </section>


            <div className="sidebar-page-container" style={{marginTop:"-100px"}}>
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="content-side col-lg-8 col-md-12 col-sm-12">
                            <div className="blog-detail">
                                <div className="blog-detail_inner">
                                    <div className="blog-detail_three-image">
                                        <img src="assets/img/Keep.jpg" alt />
                                        <a to="assets/img/Keep.jpg" className="lightbox-image news-block_three-search flaticon-search-interface-symbol" />
                                    </div>
                                    <div className="blog-detail_lower-content">
                                        <div className="d-flex flex-wrap">
                                            <div className="blog-detail_date">22 Jun, 2025</div>
                                        </div>
                                        <h3 className="blog-detail_heading">Simple defenses against the new Coronavirus</h3>
                                        <p> <b style={{color:"black"}}>Regularly wash your hands.</b> Use an alcohol-based hand rub or wash your hands with soap and water to properly clean them on a regular basis.</p>
                                        <p> <b style={{color:"black"}}> Why? </b>  Viruses on your hands can be eliminated by washing them with soap and water or applying an alcohol-based hand massage. </p>
                                        <h4> Keep your distance from people.</h4>
                                        <p>Keep a minimum of one meter (3 feet) between you and someone who is sneezing or coughing.</p>
                                        <p> <b style={{color:"black"}}> Why? </b> When someone coughs or sneezes, little liquid droplets that may contain viruses are released from their lips or nose. If the individual coughing has the COVID-19 virus, you may inhale the droplets if you are too close.</p>
                                        <div className="row clearfix">
                                            <div className="column col-lg-6 col-md-6 col-sm-12">
                                                <div className="blog-detail_three-image">
                                                    <img src="assets/img/dsd.png" alt />
                                                </div>
                                            </div>
                                        </div>
                                        <h4>Avoid touching eyes, nose and mouth</h4>
                                        <p> <b style={{color:"black"}}> Why? </b> Hands can contract viruses since they come into contact with a variety of surfaces. The infection can spread from infected hands to your mouth, nose, or eyes. The infection can then infiltrate your body and cause illness.</p>
                                        <h4>Practice respiratory hygiene</h4>
                                        <p>Make sure you maintain proper respiratory hygiene, as do those around you. When you sneeze or cough, cover your mouth and nose with a tissue or your bent elbow. Next, discard the used tissue right away.</p>
                                        <p> <b style={{color:"black"}}> Why? </b> Viruses are propagated by droplets. Maintaining proper respiratory hygiene helps shield those around you against viruses like COVID-19, the flu, and colds.</p>
                                        <h4>If you have fever, cough and difficulty breathing, seek medical care early</h4>
                                        <p>If you're feeling sick, stay at home. Seek medical treatment and make an advance call if you have a fever, cough, and breathing difficulties. Observe the guidelines provided by your local health authority.

                                        </p>
                                        <p> <b style={{color:"black"}}> Why? </b> The most recent information on the situation in your area will be available from local and national authorities. Your healthcare practitioner can promptly refer you to the appropriate medical facility if you call ahead of time. Additionally, this will shield you from viruses and other illnesses.</p>
                                        <h4>Stay informed and follow advice given by your healthcare provider</h4>
                                        <p>Keep up with the most recent COVID-19 developments. To protect yourself and others from COVID-19, heed the advise of your employer, national and local public health authorities, and your healthcare provider.</p>
                                       
                                       
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="sidebar-side col-lg-4 col-md-12 col-sm-12">
                            <aside className="sidebar sticky-top">
                                <div className="sidebar-widget expert_widget" style={{ backgroundImage: 'url(assets/images/background/pattern-33.png)' }}>
                                    <span className="color-layer" />
                                    <h3>Experienced Team of Doctors, Nurses, and Staff</h3>
                                    <Link to="/appointment" className="theme-btn btn-style-one">
                                        <span className="btn-wrap">
                                            <span className="text-one">Book Appointment</span>
                                            <span className="text-two">Book Appointment</span>
                                        </span>
                                    </Link>
                                    <div className="image">
                                        <img src="assets/images/resource/doctor-1.png" alt />
                                    </div>
                                </div>
                            </aside>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default CoronavirusInfections